import React from "react";
import Service from "./Service";
import Header from "../components/Header";
import Actualite from "../components/Actualite";
import IAGenerative from "../components/IAGenerative";
import IAAgentique from "../components/IAAgentique";
import DataAnalytique from "../components/DataAnalytique";
import Approach from "../components/Approach";
import MaturiteIa from "../components/MaturiteIa";
import BlogAccueil from "../components/BlogAccueil";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingChatbot from "../components/FloatingChatbot";
import Partenaire from "../components/Partenaire";
function HomeV3() {
  return (
    <div>
      <section>
        <Header />
      </section>
      <section id="services">
        <Service />
      </section>
      <section id="approach">
        <Approach />
      </section>
      {/* <section>
        <Actualite />
      </section> */}
      <section>
        <IAGenerative />
      </section>
      <section>
        <IAAgentique />
      </section>
      <section>
        <DataAnalytique />
      </section>
      <section>
        <MaturiteIa />
      </section>
      <section id="infos">
        <BlogAccueil />
      </section>
       <section id="partenaire">
        <Partenaire />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <section>
        <Footer />
      </section>
      <FloatingChatbot />
    </div>
  );
}
export default HomeV3;
